var map = {
	"./WhatsApp Image 2024-08-16 at 01.03.16 (1).jpeg": 9659,
	"./WhatsApp Image 2024-08-16 at 01.03.16.jpeg": 5541,
	"./WhatsApp Image 2024-08-16 at 01.03.17 (1).jpeg": 2040,
	"./WhatsApp Image 2024-08-16 at 01.03.17.jpeg": 5278,
	"./WhatsApp Image 2024-08-16 at 01.03.18.jpeg": 4287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7481;